import TermOfService from '../../components/Help/TermOfService';

const TermOfServicePage = () => {
  return <TermOfService />;
};

export default TermOfServicePage;
